// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBody_root__10HlC","body":"ErrorBody_body__1hmXC","img":"ErrorBody_img__2TkBO","fill":"ErrorBody_fill__3oJPo"};